import {AccountManagementServicesInstantiatorService} from '@modules/account-management';
import {ActivitiesServicesInstantiatorService} from '@modules/activities';
import {AuthenticationServicesInstantiatorService} from '@modules/authentication';
import {BasicPageService} from 'fuse-core/components/basic-page/basic-page.service';
import {ConfigurationService} from '@modules/configuration';
import {FormDialogService} from 'fuse-core/components/form-dialog/form-dialog.service';
import {GamificationService} from '@modules/gamification';
import {GlobalAuthorizationService} from '../../../../src/app/global-authorization.service';
import {Injectable} from '@angular/core';
import {LrsService} from '@modules/lrs';
import {NewsService} from 'fuse-core/news/news.service';
import {OnboardingService as GamificationOnboardingService} from '@modules/gamification/core/onboarding/onboarding.service';
import {SnackbarNewsService} from 'fuse-core/news/snackbar/snackbar-news.service';
import {SvgIconList} from '../../../../src/app/themes/amazon_python/svgIconList';
import {TimelineService} from '@modules/timeline';

@Injectable()
export class ServiceInstantiator {

    constructor(
        private _accountManagementServices: AccountManagementServicesInstantiatorService,
        private _activitiesServices: ActivitiesServicesInstantiatorService,
        private _authenticationServices: AuthenticationServicesInstantiatorService,
        private _basicPageService: BasicPageService,
        private _configurationService: ConfigurationService,
        private _formDialogService: FormDialogService,
        private _gamificationOnboardingService: GamificationOnboardingService,
        private _gamificationService: GamificationService,
        private _globalAuthorizationService: GlobalAuthorizationService,
        private _lrsService: LrsService,
        private _newsService: NewsService,
        private _snackbarNewsService: SnackbarNewsService,
        private _svgIconList: SvgIconList,
        private _timelineService: TimelineService,
    ) {
    }

}
